var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2ReferalStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 45L8 37.0133L10.3625 34.6173L14.3 38.6106V21.2529C14.3 18.9811 15.0962 17.0377 16.6887 15.4226C18.2812 13.8075 20.1975 13 22.4375 13C24.6775 13 26.5938 13.8075 28.1862 15.4226C29.7787 17.0377 30.575 18.9811 30.575 21.2529V36.6938C30.575 38.1137 31.0562 39.3117 32.0187 40.2879C32.9812 41.264 34.1625 41.7521 35.5625 41.7521C36.9625 41.7521 38.1437 41.264 39.1062 40.2879C40.0687 39.3117 40.55 38.1137 40.55 36.6938V19.3894L36.6125 23.3827L34.25 20.9867L42.125 13L50 20.9867L47.6375 23.3827L43.7 19.3894V36.6938C43.7 38.9656 42.9037 40.909 41.3112 42.5241C39.7187 44.1392 37.8025 44.9468 35.5625 44.9468C33.3225 44.9468 31.4062 44.1392 29.8137 42.5241C28.2212 40.909 27.425 38.9656 27.425 36.6938V21.2529C27.425 19.8331 26.9438 18.6351 25.9812 17.6589C25.0187 16.6828 23.8375 16.1947 22.4375 16.1947C21.0375 16.1947 19.8562 16.6828 18.8937 17.6589C17.9312 18.6351 17.45 19.8331 17.45 21.2529V38.6106L21.3875 34.6173L23.75 37.0133L15.875 45Z",
    fill: "#6b7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2ReferalStandard);
export default __webpack_public_path__ + "static/media/v2-referal-standard.587b173339c40c7383d5b90203c960de.svg";
export { ForwardRef as ReactComponent };